angular
	.module 'App.Repository'

.factory 'ConfigurationRepository', ['BaseRepository', (BaseRepository) ->
	class ConfigurationRepository extends BaseRepository
		@resource = '/configurations'
		@isRestricted = true

		listRoleConfigurations: (id) ->
			return @listConfigurationsForModel('roles', id)

		listShopConfigurations: (id) ->
			return @listConfigurationsForModel('shops', id)

		listConfigurationsForModel: (model, id) ->
			return @getPublicEntities('/' + model + '/' + id)

		findByIdentifierInContext: (model, id, identifier) ->
			return @getPublicEntities('/' + identifier + '/' + model + '/' + id)

		getPublicEntities: (url) ->
			query = @createQuery()
			query.addParameter('public', true)

			return @findByQuery(query, url)
				.then (response) =>
					return response.data

	return new ConfigurationRepository
]
